<template>
    <modal :show="true" :show-close="false">
        <template slot="header">
            <h5 class="modal-title">Change name</h5>
        </template>
        <template>
            <form>
                <div class="row">
                    <div class="col">
                        <base-input label="Name"
                                    type="text"
                                    placeholder="Enter name"
                                    v-model="name"
                                    name="name"
                                    v-validate="'required'"
                                    required
                                    :error="getError('name')"
                                    @input="handleNameInputChange"
                        >
                        </base-input>
                    </div>
                </div>
            </form>
        </template>


        <template slot="footer">
            <base-button type="primary" native-type="submit" @click.prevent="validate"
                         :loading="saving"> Save changes
            </base-button>
            <base-button type="secondary" @click.native="$emit('close')">Close</base-button>
        </template>
    </modal>
</template>
<script>
    import Modal from "../../../components/Modal";

    export default {
        name: 'change-student-name-modal',
        components: {
            Modal,
        },
        props: ['student'],
        data() {
            return {
                name: null,
                saving: false,
            }
        },
        mounted() {
            this.name = this.student.name;
        },
        methods: {
            getError(fieldName) {
                return this.errors.first(fieldName)
            }
            ,
            validate() {
                this.$validator.validateAll().then(isValid => {
                    if (isValid) {
                        this.save()
                    }
                })
            },
            handleNameInputChange(value) {
                this.name = value.replace(/[#,"'/\\`~:;}{|$&%^?+*]/g, '');
            },
            save() {
                this.saving = true;
                this.$emit('save', {new_name: this.name});
            },
        },
    }
</script>
